<template>
  <div class="gm-admin-tab">
    <div class="gm-admin-tab__head">
      <div>
        <h2>{{ $t('frontend_groovemail_admin_bcc_email_settings') }}</h2>
        <p class="gm-admin-tab__hint">{{ $t('frontend_groovemail_save_note_for_bcc_email') }}</p>
      </div>
      <gs-button variant="primary" @click="updateCopiedMails()">{{ $t('frontend_save') }}</gs-button>
    </div>

    <div class="gm-admin-tab__row gm-admin-tab__row--inline">
      <gs-field class="gs-field--grow" :label="$t('frontend_groovemail_admin_settings_enter_email')">
        <text-input
          variant="base"
          v-model="model.email"
          :validator="$v.model.email"
          :placeholder="this.$t('frontend_groovemail_admin_settings_enter_email')"
        />
      </gs-field>
      <gs-button variant="outline" class="gm-admin-tab__inline-action" @click="addEmail()">
        {{ this.$t('frontend_add') }}
      </gs-button>
    </div>

    <p class="gm-admin-tab__note gm-admin-tab__note--spaced">
      <InfoIcon />
      {{ $t('frontend_groovemail_save_note_for_bcc_email') }}
    </p>

    <div class="gm-admin-tab__chips">
      <Chip
        v-if="copiedEmails && copiedEmails.length"
        :chipData="emailArray"
        :showAction="true"
        @deleteChip="deleteEmail"
      ></Chip>
    </div>
  </div>
</template>

<script>
import {
  required,
  minLength,
  maxLength,
  email,
} from 'vuelidate/lib/validators';
import { adminUrls } from '@/utils/urls.js';
import { getData, postData } from '@/utils/apiHelper.js';
import Chip from '@/components/Chip.vue';
import { showErrorDialog } from '@/components/showDialog.js';

// import icons
import InfoIcon from '@/assets/images/icons/new/info_new.svg';

export default {
  data() {
    return {
      model: {
        email: '',
      },
      copiedEmails: [],
      bccEmailsCountChanged: false,
    };
  },

  validations: {
    model: {
      email: {
        required,
        email,
        minLength: minLength(3),
        maxLength: maxLength(50),
      },
    },
  },
	  
  components: {
    Chip,
    InfoIcon,
  },
  
  computed: {
    /**
     * Returns email data for chip component.
     * @return {array} bcc emails
     */
    emailArray() {
      const emailArr = [];
      this.copiedEmails.forEach((element) => {
        emailArr.push({ name: element });
      });
      return emailArr;
    },
  },

  // Initializes data properties with bcc email data .
  async created() {
    await this.initializeBccEmailData();
  },

  methods: {
    // Fetches bcc email data and initializes them to data properties.
    async initializeBccEmailData() {
	    const emailResponse = await getData(adminUrls.mainSettingsUrl.fetchBccEmailsData);
      if (
        emailResponse.data &&
        emailResponse.data.bccEmails &&
        emailResponse.data.bccEmails.length
      ) {
        this.copiedEmails = emailResponse.data.bccEmails;
      }
    },

    // Add email entered by admin to an array if it is valid.
    addEmail() {
      this.updateBccEmailsCount(true);
      this.$v.model.email.$touch();
      const emailValid = !this.$v.model.email.$invalid;
      if (emailValid) {
        this.copiedEmails.push(this.model.email);
        this.model.email = '';
        this.$v.model.email.$reset();
      }
    },

	  /**
     * Used to delete email from array & save it's result.
     * @param {number} index index from where user wants to delete.
     */
    async deleteEmail(_, index) {
      this.updateBccEmailsCount(true);
      if (index > -1) {
        this.copiedEmails.splice(index, 1);
      }
    },

    // Used to save email data.
	  async updateCopiedMails() {
      if (this.bccEmailsCountChanged) {
        await postData(adminUrls.mainSettingsUrl.updateBccEmails, {
          bccEmails: this.copiedEmails,
        });
        this.updateBccEmailsCount(false);
      } else {
        await showErrorDialog(
          '',
          this.$t('frontend_groovemail_admin_bcc_emails_add_remove_emails_warning')
        );
      }
    },
	
    /**
     * Used to update the parameter that defines whether bcc emails count has changed or not.
     * @param {boolean} countChanged count changed or not
     */
    updateBccEmailsCount(countChanged) {
      this.bccEmailsCountChanged = countChanged;
    },
  },
};
</script>